import gql from "graphql-tag";

export const CONCRETE_FAMILIES_QUERY = gql`
  query {
    concreteFamilies {
      id
      name
      use
      cementType {
        id
        name
      }
      gravelType
      slump {
        id
        description
      }
    }
  }
  `;

export const CONCRETE_FORMULAS_QUERY = gql`
  query($concreteFamilyIds: [Int], $is_active: Boolean) {
    concreteFormulas(
      concreteFamilyIds: $concreteFamilyIds,
      active: $is_active
    ) {
      id
      code
      fck
      use
      consumption
      wcRatio
      version
      price
      is_active
      updatedAt
    }
  }
`;

export const DELETE_CONCRETE_FAMILY_MUTATION = gql`
  mutation($id: Int!) {
    deleteConcreteFamily(
      id: $id
    ) {
      id
    }
  }
`;
